module.exports = __webpack_public_path__ + "img/other phones@2x.fc57bf4a.png";